"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUserBankAccount = exports.putUserBankAccount = exports.postUserBankAccount = exports.getUserBankAccounts = void 0;
const getUserBankAccounts = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/user-bank-accounts`, {
  withCredentials: true
});
exports.getUserBankAccounts = getUserBankAccounts;
const postUserBankAccount = (serverURL, appAxios) => async (file, data) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("accountType", data.accountType);
  formData.append("bankName", data.bankName);
  formData.append("accountName", data.accountName);
  formData.append("accountNumber", data.accountNumber);
  formData.append("bankCountry", data.bankCountry);
  if (data.sortCode) formData.append("sortCode", data.sortCode);
  if (data.accountNickname) formData.append("accountNickname", data.accountNickname);
  if (data.swift) formData.append("swift", data.swift);
  if (data.iban) formData.append("iban", data.iban);
  if (data.entityId) formData.append("entityId", data.entityId);
  if (data.routingNumber) formData.append("routingNumber", data.routingNumber);
  if (data.purposeCode) formData.append("purposeCode", data.purposeCode);
  return await appAxios.post(`${serverURL}/user-bank-accounts`, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
exports.postUserBankAccount = postUserBankAccount;
const putUserBankAccount = (serverURL, appAxios) => async (id, data, file) => {
  const formData = new FormData();
  if (file) formData.append("file", file);
  if (data.accountType) formData.append("accountType", data.accountType);
  if (data.bankName) formData.append("bankName", data.bankName);
  if (data.accountName) formData.append("accountName", data.accountName);
  if (data.accountNumber) formData.append("accountNumber", data.accountNumber);
  if (data.bankCountry) formData.append("bankCountry", data.bankCountry);
  if (data.sortCode) formData.append("sortCode", data.sortCode);
  if (data.accountNickname) formData.append("accountNickname", data.accountNickname);
  if (data.swift) formData.append("swift", data.swift);
  if (data.iban) formData.append("iban", data.iban);
  if (data.entityId) formData.append("entityId", data.entityId);
  if (data.routingNumber) formData.append("routingNumber", data.routingNumber);
  if (data.purposeCode) formData.append("purposeCode", data.purposeCode);
  return await appAxios.put(`${serverURL}/user-bank-accounts/${id}`, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
exports.putUserBankAccount = putUserBankAccount;
const deleteUserBankAccount = (serverURL, appAxios) => async id => await appAxios.delete(`${serverURL}/user-bank-accounts/${id}`, {
  withCredentials: true
});
exports.deleteUserBankAccount = deleteUserBankAccount;